import { render, staticRenderFns } from "./RadioFormItem.vue?vue&type=template&id=1b5c8c0a&"
import script from "./RadioFormItem.vue?vue&type=script&lang=js&"
export * from "./RadioFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../BougeMaVille-reborn-client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports